import { render } from "./CreateEntite.vue?vue&type=template&id=66a0e21d"
import script from "./CreateEntite.vue?vue&type=script&lang=js"
export * from "./CreateEntite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__